// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BundleDetails_bundle-details-wrapper__0fY8n {
  margin-bottom: 50rem;
}

.BundleDetails_bundle-details__loading__dvWQE {
  margin: 8rem auto;
  width: 8rem;
  height: 8rem;
}

.BundleDetails_bundle-details__empty__JWkk4 {
  margin-top: 10rem;
}

.BundleDetails_bundle-details__empty__JWkk4 .icon-wrapper {
  padding: 2rem;
}
.BundleDetails_bundle-details__empty__JWkk4 .icon {
  width: 6rem;
  height: 6rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/BundleDetails/BundleDetails.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".bundle-details-wrapper {\n  margin-bottom: 50rem;\n}\n\n.bundle-details__loading {\n  margin: 8rem auto;\n  width: 8rem;\n  height: 8rem;\n}\n\n.bundle-details__empty {\n  margin-top: 10rem;\n}\n\n.bundle-details__empty :global(.icon-wrapper) {\n  padding: 2rem;\n}\n.bundle-details__empty :global(.icon) {\n  width: 6rem;\n  height: 6rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bundle-details-wrapper": `BundleDetails_bundle-details-wrapper__0fY8n`,
	"bundle-details__loading": `BundleDetails_bundle-details__loading__dvWQE`,
	"bundle-details__empty": `BundleDetails_bundle-details__empty__JWkk4`
};
export default ___CSS_LOADER_EXPORT___;
